export default class EnquirySourcesManagementService {
  constructor($http, appConfig) {
    "ngInject";

    this.$http = $http;
    this.appConfig = appConfig;
  }

  list(entityId, enabledOnly) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/enquirysources/list/${entityId}/${enabledOnly}`);
  }

  add(entityId, enquirySource) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/enquirysources/add/${entityId}`, enquirySource);
  }

  update(entityId, enquirySource) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/enquirysources/update/${entityId}`, enquirySource);
  }

  delete(entityId, enquirySourceId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/enquirysources/delete/${entityId}/${enquirySourceId}/`);
  }

  toggleEnabled(entityId, enquirySourceId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/enquirysources/toggle/${entityId}/${enquirySourceId}/`);
  }  
}



// WEBPACK FOOTER //
// ./client/app/components/admin/enquirySourceManagement/EnquirySourcesManagement.Service.js